module.exports = function (popstate) {
    if (this.scroll && !popstate) {
        if (this.scrollToElement) {
            var self = this
            function doScrollingWhenReady () {
                var element = document.querySelector(self.scrollToElement)
                if (element != null) {
                    if (this.animateScrollToAnchor) {
                        this.scrollTo(document.body, element.offsetTop, 320)
                    } else {
                        window.scrollTo(0, element.offsetTop)
                    }
                } else {
                    console.warn(`Element for offset not found(${this.scrollToElement})`)
                }
                self.scrollToElement = null;
                console.log(self)
                document.removeEventListener('xhr2:contentReplaced', doScrollingWhenReady)
            }

            document.addEventListener('xhr2:contentReplaced', () => {

            })
        } else {
            if (this.mobile && !this.animateScrollOnMobile) {
                this.scrollTo(document.body, 0, 0)
            } else if (this.mobile && this.animateScrollOnMobile) {
                this.scrollTo(document.body, 0, 640)
            } else {
                this.scrollTo(document.body, 0, 320)
            }
        }
    }
}




// WEBPACK FOOTER //
// ./core/xhr2/modules/doScrolling.js